import { post,uploadFile, get } from './index'
import axios from 'axios'
import qs from 'qs'

export const login = params => {
  return post('/api/auth/login', params)
}

export const logout = params => {
  return post('/api/auth/logout', params)
}
export const codeLogin = params => {
  return post('/api/auth/code_login', params)
}

export const uploadBase64 = params => {
  return post('api/general/upload_binary', params)
}


